module.exports = __webpack_public_path__ + "media/images/malvinas/background-18ff502dff5d07a57052625138d4e9fc.svg";